import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualUsagePeriodHintsRequestSchema,
  TGetAccrualUsagePeriodHintsResponseSchema,
} from "./getAccrualUsagePeriodHints.schema";

export const getAccrualUsagePeriodHints = (axios: IAxiosInstance) => {
  return async (params: TGetAccrualUsagePeriodHintsRequestSchema) => {
    const { data } = await axios.noRetry.get<
      IApiResponse<TGetAccrualUsagePeriodHintsResponseSchema>
    >(`/accrual-policies/usage-period-hints`, {
      params: {
        companyID: params.companyID,
        employee_id: params.employee_id,
        policy_id: params.policy_id,
      },
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
